import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { mediaQuery } from '@picsart/rc/helpers';
import {
  ControlBackgroundColors,
  ControlTextColors,
  ControlValueColors,
} from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s8,
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    select: {
      '& button': {
        '& > svg[data-testid="start-icon"]': {
          display: 'none',
        },
      },
      minWidth: 'max-content',
    },
    selectItem: {
      color: ControlTextColors.activeAction,
    },
    active: {
      '& button': {
        color: ControlValueColors.active,
        backgroundColor: ControlBackgroundColors.active,
        textTransform: 'capitalize',
      },
    },
    activeItem: {
      color: ControlValueColors.active,
      backgroundColor: ControlBackgroundColors.active,
    },
    root: {
      width: '100%',
    },
    stickyContainer: {
      '& > div': {
        margin: 0,
      },
      overflow: 'hidden',
      width: '100%',
      paddingInline: Spacings.s24,
      [mediaQuery(BreakPoints.Small)]: {
        paddingInline: 0,
      },
    },
    skeletonRoot: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s24,
    },
    subCategorySkeleton: {
      marginTop: Spacings.s40,
    },
  },
  {
    name: 'content',
  },
);

export default useStyles;
